// Lists outbox creates/edits waiting to sync when the device is back online.
import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { Page, List, Block, BlockTitle, Button } from "framework7-react";
import moment from "moment";
import AppNavbar from "modules/1_layout/mobile/AppNavbar";
import { retryFailedNow } from "./sync";
import PendingSyncItem, { syncSummary } from "./PendingSyncItem";

const mapStateToProps = (state) => ({
  pendingItems: state.offline_status?.pendingItems || [],
  online: state.offline_status?.online,
  syncing: state.offline_status?.syncing,
  lastSyncedAt: state.offline_status?.lastSyncedAt,
  projects: state.projects,
});

const listPathFromUrl = (url = "") => {
  const path = url.split("?")[0].replace(/\.json$/, "");
  return path.replace(/\/(\d+|[0-9a-f-]{36})$/i, "");
};

const projectNameFor = (item, projects) => {
  if (!item.projectId) return null;
  return projects?.[item.projectId]?.display_name || projects?.[String(item.projectId)]?.display_name || null;
};

const PendingSyncPage = ({ pendingItems, online, syncing, lastSyncedAt, projects }) => (
  <Page>
    <AppNavbar title="Needs syncing" />
    <BlockTitle>
      {pendingItems.length} waiting
      {online ? (syncing ? " — sending…" : " — will send when Lion answers") : " — offline"}
    </BlockTitle>
    <Block>
      {syncSummary(pendingItems)}
      {lastSyncedAt ? ` · Last synced ${moment(lastSyncedAt).fromNow()}` : ""}
    </Block>
    {online && (
      <Block>
        <Button fill onClick={() => retryFailedNow()} disabled={syncing}>
          {syncing ? "Syncing…" : "Sync now"}
        </Button>
      </Block>
    )}
    {_.isEmpty(pendingItems) ? (
      <Block>Nothing waiting to sync.</Block>
    ) : (
      <List mediaList>
        {_.map(_.sortBy(pendingItems, "createdAt").reverse(), (item) => (
          <PendingSyncItem
            key={item.id}
            item={item}
            projectName={projectNameFor(item, projects)}
            link={listPathFromUrl(item.url)}
          />
        ))}
      </List>
    )}
  </Page>
);

export default connect(mapStateToProps)(PendingSyncPage);
